<template>
    <div class="organization">
        <div class="title">
            <img class="title_img" src="../../../assets/images/08/zuzhi_icon.png" alt="">
            组织结构
        </div>
        <div class="addBtn">
            <router-link to="organiz/addOrganization">
                <el-button
                    type="warning"
                    size="small"
                    class="add_btn"
                >添加</el-button>
            </router-link>
        </div>
        <div class="main">
            <el-table
                :data="data"
                ref="multipleTable"
                style="width: 100%"
                class="main-data"
                height="100%"
                >
                <!-- <el-table-column
                    class-name="number"
                    label=" "
                    align="center"
                    width="50"
                >
                    <template  slot-scope="scope">
                        <div
                        >aaa</div>
                    </template>
                </el-table-column> -->
                <el-table-column
                    header-align="center"
                    align="left"
                    label="结构名称"
                >
                    <template slot-scope="scope">
                        <div
                            class="structureName"
                            @click="toggle(scope.row)"
                            size="medium">{{scope.row.name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="编号"
                    header-align="center"
                    align="center"
                >
                    <template slot-scope="scope">
                    <div>{{scope.row.encoding}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="分类"
                    header-align="center"
                    align="center"
                >
                <template slot-scope="scope">
                   <div size="medium" v-if="scope.row.type===0">公司</div>
                   <div size="medium" v-if="scope.row.type===1">部门</div>
                </template>
                </el-table-column>
                <el-table-column
                    label="备注"
                    header-align="center"
                    align="center"
                >
                <template slot-scope="scope">
                    <div>{{scope.row.remark}}</div>
                </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    class="operation"
                    header-align="center"
                    align="center"
                    width="165"
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item addNew"
                            effect="dark"
                            content="添加子结构"
                            placement="top"
                        >
                            <el-button
                            @click="handleAddChildClick(scope.row.id)"
                            ></el-button>
                        </el-tooltip>
                        <el-tooltip
                            class="item update"
                            effect="dark"
                            content="修改"
                            placement="top"
                        >
                            <el-button
                            @click="handleUpdateClick(scope.row.id)"
                            ></el-button>
                        </el-tooltip>

                        <el-tooltip
                            class="item delete"
                            effect="dark"
                            content="删除"
                            placement="top"
                        >
                            <el-button
                            @click="handleDeleteClick(scope.row.id)"
                            ></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    type="expand">
                    <template  slot-scope="scope">
                        <el-table
                            :data="scope.row.officeList"
                            class="detailTable"
                        >
                            <el-table-column
                                align="center"
                            >
                                <template slot-scope="props">
                                    <div class="subTitlename">{{props.row.name}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                            >
                                <template slot-scope="props">
                                    <div>{{props.row.encoding}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                            >
                                <template slot-scope="props">
                                    <div v-if="props.row.type===0">公司</div>
                                    <div v-if="props.row.type===1">部门</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                align="center"
                            >
                                <template slot-scope="props">
                                    <div>{{props.row.remark}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                width="165"
                            >
                                <template slot-scope="props">
                                    <el-tooltip
                                        class="item update"
                                        effect="dark"
                                        content="修改"
                                        placement="top"
                                    >
                                        <el-button
                                        @click="handleUpdateClick(props.row.id)"
                                        ></el-button>
                                    </el-tooltip>

                                    <el-tooltip
                                        class="item delete"
                                        effect="dark"
                                        content="删除"
                                        placement="top"
                                    >
                                        <el-button
                                        @click="handleDeleteClick(props.row.id)"
                                        ></el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column
                                type="expand"
                            >
                            </el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div class="pages">
            <span class="demonstartion"> 共{{emailData.total}}条记录</span>
            <el-pagination
                @current-change="handleCurrentChange"
                :page-size="emailData.pageSize"
                layout="prev, pager, next"
                :total="emailData.total"
                background
            >
            </el-pagination>
        </div> -->
    </div>
</template>
<script>
import { organizationList, deleteOrganization } from 'apis/index'
export default {
  name: 'operation',
  data () {
    return {
      data: []
    }
  },
  methods: {
    getData () { // 获取数据
      organizationList().then(res => {
        if (res.data.code === 200) {
          this.data = res.data.data
        }
      })
    },
    toggle (row) { // 子结构
      this.$refs.multipleTable.toggleRowExpansion(row)
    },
    handleAddChildClick (id) { // 添加子结构
      this.$router.push({path: 'organiz/addOrganization', query: {'add': id}})
    },
    handleUpdateClick (id) { // 修改公司/子结构
      this.$router.push({path: 'organiz/addOrganization', query: {'company': id}})
    },
    handleDeleteClick (id) { // 删除公司/子结构
      deleteOrganization({id: id}).then(res => {
        if (res.data.code === 200) {
          for (var i = 0; i < this.data.length; i++) { // 从当前列别表中删除该数据
            if (this.data[i].id === id) {
              this.data.splice(i, 1)
            }
            for (var j = 0; j < this.data[i].officeList.length; j++) {
              if (this.data[i].officeList[j].id === id) {
                this.data[i].officeList.splice(j, 1)
              }
            }
          }
        }
      })
    },

    handleCurrentChange (val) { // 分页
    //   let pageNum = val
    //   emailList({pageNum}).then(res => {
    //     if (res.data.code === 200) {
    //       this.emailData = res.data.data
    //     }
    //   })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.organization
    height 100%
    padding 20px
    .title
      width 100%
      height 46px
      line-height 46px
      color #212832
      background #fff
      border-bottom 1px solid #cfd5dc
      .title_img
        margin 0 8px 0 14px
    .addBtn
        width 100%
        height 46px
        background #fff
        .add_btn
            padding 7px 26px
            float right
            margin-top 10px
            margin-right 20px
    .main
        width 100%
        height calc(100% - 115px)
        background #ff738f
        .el-table
            th
                background #e7f0f8
                .cell
                    height 25px
                    line-height 25px
            td
                height 80px

                .cell
                    size12()
                    .structureName
                        padding-left 80px
                        cursor pointer
                        background-image url('../../../assets/images/08/company.png') , url('../../../assets/images/08/xiala_n_icon.png')
                        background-repeat no-repeat,no-repeat
                        background-position 47px , 24px
                        &:hover
                            background-image url('../../../assets/images/08/company.png') , url('../../../assets/images/08/xiala_h_icon.png')
                            background-repeat no-repeat,no-repeat
                            background-position 47px , 24px
                    .el-icon-arrow-right:before
                        content ''

                    .el-button
                        padding 6px 14px
                        width 28px
                        cursor pointer
                        height 28px
                        margin 0 8px
                        &.update
                            update01()
                        &.unblocked
                            unblocked01()
                        &.delete
                            delete01()
                        &.addNew
                            addNew01()
            .el-table
                thead
                    display none
                td
                 .cell
                    .subTitlename
                        padding-left 95px
            .el-table__expanded-cell
                padding 0
            .el-table td, .el-table th.is-leaf
                border-bottom none
                background #E6F3FE
    .el-pagination
        color #5e656f
        font-weight 100
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
        border 1px solid #cfd5dc
        background #fff

    .pages
        margin-top 15px
        .demonstartion
            float right
            line-height 45px
            color #5e656f

</style>
